export const SWITCH_THEME = 'SWITCH_THEME'
export const SWITCH_LANG = 'SWITCH_LANG'
export const SET_DARK_MODE_FROM_STORAGE = 'SET_DARK_MODE_FROM_STORAGE'
export const SET_LANG_FROM_STORAGE = 'SET_LANG_FROM_STORAGE'